@if(firstLoad){
<div class="loader-template"></div>
<div class="as-fixed-loader">
  <ng-lottie width="150px" height="150px" [options]="options"> </ng-lottie>
  <mat-label class="as-roboto-slab as-font-bold as-font-20 as-font-red">
    {{ 'GENERAL.loading' | translate }}...
  </mat-label>
</div>
}@else{
<main>
  <section *ngIf="!isMobile; else mobileView">
    <div class="left">
      <p class="as-font as-font-semibold as-font-black as-font-16">
        {{ 'FILTER.filterBy' | translate }}
      </p>

      <div class="as-brand-container">
        <div>
          <p class="as-font as-font-semibold as-font-16 as-font-black">
            {{ 'FILTER.categories' | translate }}
          </p>
        </div>
        <div class="as-column as-filter-scroll">
          <mat-checkbox
            [checked]="subcategory.checked"
            *ngFor="let subcategory of subcategories; let i = index"
            (change)="filterSubcategory(subcategory.subcategory, i, $event)"
          >
            <mat-label
              class="as-font as-font-grey-75 as-font-16 as-font-semibold as-font-oneline"
            >
              {{ subcategory.subcategory | titlecase }}
              <span class="as-font as-font-14 as-font-normal"
                >({{ subcategory.total }})</span
              >
            </mat-label>
          </mat-checkbox>
        </div>
      </div>

      <div class="as-brand-container">
        <div>
          <p class="as-font as-font-semibold as-font-16 as-font-black">
            {{ 'FILTER.brand' | translate }}
          </p>
        </div>
        <div class="as-column as-filter-scroll">
          <mat-checkbox
            [checked]="brand.checked"
            *ngFor="let brand of brands; let i = index"
            (change)="filterBrand(brand.brand, i, $event)"
          >
            <mat-label
              class="as-font as-font-grey-75 as-font-16 as-font-semibold"
            >
              {{ brand.brand | titlecase }}
              <span class="as-font as-font-14 as-font-normal"
                >({{ brand.total }})</span
              >
            </mat-label>
          </mat-checkbox>
        </div>
      </div>

      <div class="as-column as-gap-10 as-price-wrapper">
        <p class="as-font as-font-semibold as-font-black as-font-16">
          {{ 'FILTER.byPrice' | translate }}
        </p>
        <div class="as-price-container">
          <mat-form-field appearance="outline" color="accent">
            <mat-label>{{ 'FILTER.from' | translate }}</mat-label>
            <input
              placeholder="$"
              [formControl]="minPriceForm"
              type="number"
              matInput
              [max]="maxPriceForm.value"
              min="0"
            />
          </mat-form-field>
          <mat-form-field appearance="outline" color="accent">
            <mat-label>{{ 'FILTER.until' | translate }}</mat-label>
            <input
              placeholder="$"
              [min]="minPriceForm.value"
              [formControl]="maxPriceForm"
              type="number"
              matInput
            />
          </mat-form-field>
        </div>
      </div>

      <div class="as-delete-filters as-pointer" (click)="handleDeleteFilters()">
        <p
          class="as-font as-font-open-sans as-font-semibold as-font-underline as-font-red as-font-14"
        >
          {{ 'Eliminar filtros' }}
        </p>
      </div>

      <div class="as-column as-gap-8 as-price-wrapper">
        <p class="as-font as-font-semibold as-font-blackk as-font-16">
          {{ 'FILTER.order' | translate }}
        </p>
        <mat-radio-group
          aria-labelledby="example-radio-group-label"
          class="as-column as-gap-8"
          [(ngModel)]="selectedOption"
        >
          <mat-radio-button
            *ngFor="let radio of radioButtonOptions"
            [value]="radio"
            (change)="selectOrder(radio)"
          >
            <p class="as-font as-font-grey-75 as-font-16">
              {{ radio.label }}
            </p>
          </mat-radio-button>
        </mat-radio-group>
      </div>
    </div>

    @if(!emptyProducts){
    <div class="right">
      <label class="as-title-text">
        {{ carousel.title | titlecase }}
      </label>
      <span class="as-font-14 as-font-grey-75">
        {{ productsLength + ' productos' }}
      </span>
      <div class="as-product-card-container as-wrap as-gap-8 as-pt-8">
        <app-product-card
          class="carousel-cell"
          *ngFor="let product of products"
          [product]="product"
        >
        </app-product-card>
      </div>
      @if(shouldLoadMore){
      <div id="loader" class="as-loader-container" *ngIf="shouldLoadMore">
        <ng-lottie width="150px" height="150px" [options]="options">
        </ng-lottie>
        <mat-label class="as-roboto-slab as-font-bold as-font-20 as-font-red">
          {{ 'GENERAL.loading' | translate }}...
        </mat-label>
      </div>
      }@else{
      <div class="as-loader-container" *ngIf="loading">
        <ng-lottie width="150px" height="150px" [options]="options">
        </ng-lottie>
        <mat-label class="as-roboto-slab as-font-bold as-font-20 as-font-red">
          {{ 'GENERAL.loading' | translate }}...
        </mat-label>
      </div>
      }
    </div>
    }@else{
    <div class="as-notfound-template-container">
      <div class="as-not-found-container">
        <div>
          <mat-label class="as-font as-font-bold as-error-title">
            {{ 'ERROR-MESSAGES.noMatches' | translate }}
          </mat-label>
        </div>
        <div class="as-not-found-message-container">
          <div>
            <mat-label class="as-font as-error-body">
              {{ 'ERROR-MESSAGES.tryAnotherAdvice' | translate }}
            </mat-label>
          </div>
          <button
            mat-button
            color="accent"
            class="btn-deals"
            [routerLink]="['/ofertas']"
          >
            <mat-label class="as-font as-font-semibold as-font-green">
              {{ 'ERROR-MESSAGES.viewDeals' | translate }}
            </mat-label>
          </button>
        </div>
      </div>
    </div>
    }
  </section>

  <ng-template #mobileView>
    <section>
      <div class="as-mobile-view">
        <div class="as-mobile-container">
          <div class="as-mobile-filters-container">
            <div class="as-mobile-filters-title">
              <p class="as-font-14 as-font-bold as-font-oneline">
                {{ carousel.title | titlecase }}
              </p>
            </div>
            <div class="as-mobile-filters">
              <div>
                <p class="as-font-12 as-font-bold as-font-grey-75">
                  {{ productsLength + ' productos' }}
                </p>
              </div>
              <div class="as-button-filter-container">
                <button
                  mat-stroked-button
                  matPrefix
                  color="accent"
                  class="as-button-filter"
                  (click)="openFilterModal()"
                >
                  <mat-icon svgIcon="ic-filter-dept"></mat-icon>
                  <mat-label class="as-font">
                    {{ 'FILTER.filter' | translate }}
                  </mat-label>
                </button>
                <button
                  mat-stroked-button
                  matPrefix
                  color="accent"
                  class="as-button-filter"
                  (click)="openOrderModal()"
                >
                  <mat-icon svgIcon="ic-sort"></mat-icon>
                  <mat-label class="as-font">
                    {{ 'FILTER.order' | translate }}
                  </mat-label>
                </button>
              </div>
            </div>
            <div
              class="as-row as-align-center as-gap-10 as-mobile-filters-chips-container"
            >
              <div
                class="as-mobile-filters-chips"
                *ngIf="filters.min_price || filters.max_price"
              >
                <div *ngIf="filters.min_price && !filters.max_price">
                  <p>Desde {{ filters.min_price | currency : '$' }}</p>
                  <mat-icon
                    (click)="deletePrice()"
                    svgIcon="ic-close-green"
                  ></mat-icon>
                </div>
                <div *ngIf="!filters.min_price && filters.max_price">
                  <p>Hasta {{ filters.max_price | currency : '$' }}</p>
                  <mat-icon
                    (click)="deletePrice()"
                    svgIcon="ic-close-green"
                  ></mat-icon>
                </div>
                <div *ngIf="filters.min_price && filters.max_price">
                  <p>
                    {{ filters.min_price | currency : '$' }} -
                    {{ filters.max_price | currency : '$' }}
                  </p>
                  <mat-icon
                    (click)="deletePrice()"
                    svgIcon="ic-close-green"
                  ></mat-icon>
                </div>
              </div>
              <div class="as-mobile-filters-chips" *ngIf="filters.subcategory">
                <div *ngFor="let filter of filters.subcategory.split(',')">
                  <p>{{ filters.subcategory | titlecase }}</p>
                  <mat-icon
                    class="as-pointer"
                    (click)="deleteSubcategory(filter)"
                    svgIcon="ic-close-green"
                  ></mat-icon>
                </div>
              </div>
              <div class="as-mobile-filters-chips" *ngIf="filters.brand">
                <div *ngFor="let filter of filters.brand.split(',')">
                  <p>{{ filter | titlecase }}</p>
                  <mat-icon
                    class="as-pointer"
                    (click)="deleteBrand(filter)"
                    svgIcon="ic-close-green"
                  ></mat-icon>
                </div>
              </div>
            </div>
          </div>
          @if(!emptyProducts){
          <div class="as-mobile-items-container">
            <div class="as-row as-wrap as-gap-8 as-mobile-items">
              <app-product-card
                class="carousel-cell as-margin-auto"
                *ngFor="let product of products"
                [product]="product"
              >
              </app-product-card>
            </div>
          </div>
          <div id="loader" class="as-loader-container" *ngIf="shouldLoadMore">
            <ng-lottie width="150px" height="150px" [options]="options">
            </ng-lottie>
            <mat-label
              class="as-roboto-slab as-font-bold as-font-20 as-font-red"
            >
              {{ 'GENERAL.loading' | translate }}...
            </mat-label>
          </div>
          }@else{
          <div class="as-notfound-template-container">
            <div class="as-not-found-container">
              <div>
                <mat-label class="as-font as-font-bold as-error-title">
                  {{ 'ERROR-MESSAGES.noMatches' | translate }}
                </mat-label>
              </div>
              <div class="as-not-found-message-container">
                <div>
                  <mat-label class="as-font as-error-body">
                    {{ 'ERROR-MESSAGES.tryAnotherAdvice' | translate }}
                  </mat-label>
                </div>
                <button
                  mat-button
                  color="accent"
                  class="btn-deals"
                  [routerLink]="['/ofertas']"
                >
                  <mat-label class="as-font as-font-semibold as-font-green">
                    {{ 'ERROR-MESSAGES.viewDeals' | translate }}
                  </mat-label>
                </button>
              </div>
            </div>
          </div>
          }
        </div>
      </div>
    </section>
  </ng-template>
</main>
}
